import React from "react";
import { css, ClassNames } from "@emotion/core";
import Img from "gatsby-image";
import FullWidthImage from "./FullwidthImage";

const cardStyles = css`
  margin-bottom: 24px;
  border-radius: 4px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25), 0px 1px 8px rgba(0, 0, 0, 0.15);
`;

const cardContentStyles = css`
  padding: 16px;
`;

const cardHeaderStyles = css`
  margin: 0;

  font-size: 32px;
`;

const heroStyles = css`
  border-radius: 4px 4px 0 0;

  overflow: hidden;
`;

const Card = ({ header, children, hero, style }) => {
  let HeroImage;

  if (hero && typeof hero === "string") {
    HeroImage = <FullWidthImage css={heroStyles} src={hero} alt="Puppy" />;
    // Check if hero is gatsby image sharp object
  } else if (hero && typeof hero === "object" && hero.src && hero.sizes) {
    HeroImage = (
      <ClassNames>
        {({ css, cx }) => <Img className={css(heroStyles)} fluid={hero} />}
      </ClassNames>
    );
  }

  return (
    <div css={[cardStyles, style]}>
      {HeroImage}
      <div css={cardContentStyles}>
        <h1 css={cardHeaderStyles} className="light">
          {header}
        </h1>
        {children}
      </div>
    </div>
  );
};

export default Card;
